import React, { useEffect, useMemo, useState } from 'react';



import { Box, Button, FormField, Link, Pagination, Popover, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import { mdiClipboardCheck, mdiClockRemoveOutline, mdiCloseOctagon, mdiFileExcel, mdiHelpRhombus, mdiHumanMaleBoard, mdiTabSearch, mdiThumbDown, mdiThumbUp, mdiTimerSettings } from '@mdi/js';
import Icon from '@mdi/react';
import { setParameters } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { btnIconForm, ItemCheck } from '../../resources/types';
import StepsCheck from '../extras/StepsCheck';
import SelectPaging from '../selects/selectPaging';


interface TableChecksProps {
    checks?: ItemCheck[];
    showUser?: boolean;
    showEquipment?: boolean;
    excel?: boolean;
    filter?: boolean;
    refresh?: boolean;
    hidePaging?: boolean;
    showPilot?: boolean;
    showInstructor?: boolean;
    showStatus?: boolean;
    showEval?: boolean;
    onRefresh?: () => void; // ← optional now
    onSelect?: (selectedRow: any) => void; // ← optional now
    onCounter?: (counter: string) => void; // ← optional now
    onRangeChange?: (startDate: string, endDate: string) => void; // ← optional now
    records?: number;
    //onDismiss: () => void;
    //onConfirm: (selectedDate: string) => void;
}

const TableChecks: React.FC<TableChecksProps> = ({
    checks = [],
    filter = true,
    showUser = true,
    showEquipment = true,
    hidePaging = false,
    excel = false,
    showPilot = true,
    showInstructor = true,
    showEval = false,
    showStatus = true,
    onSelect,
    onCounter,
    onRefresh,
    onRangeChange,
    refresh = true
}) => {

    //const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const { parameters, data } = useGlobalState();

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");
    const [movementsExcel, setMovementsExcel] = useState<any[]>([]);
    const filtered: ItemCheck[] = checks.filter((item: ItemCheck) => {

        const normalize = (str: string | undefined | null) =>
            (str || "")
                .toString()
                .toLowerCase()
                .normalize("NFD") // Decomposes accented characters (e.g., 'í' -> 'i' + '◌́')
                .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
                .replace(/[^a-z0-9]/g, ""); // Removes non-alphanumeric

        const searchWords = normalize(filterValue).split(/\s+/).filter(Boolean);
        const text = normalize([item.displayName ?? "", item.check ?? "", item.displayName ?? "", item.instructor ?? "", item.idRequest.toString() ?? ""].join(" "));
        return searchWords.every((word) => text.includes(normalize(word)));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);


    {/*
                        counter={pendings.length > 0 ? pendings.length === filteredChecks.length ? pendings.length.toString() : `${filteredChecks.length} de ${pendings.length}` : undefined}
                        */}
    useEffect(() => {
        if (onCounter) {
            onCounter(filtered.length === checks.length ? `${checks.length}` : `${filtered.length} de ${checks.length}`);
        }
    }, [filtered.length, checks.length, onCounter]);
    const exportToExcel = () => {
        // Convert JSON to worksheet
        /*
                let mExcel: any[] = (filtered.map((fl: ItemCheck) => ({
                    ID: fl.idMaintenance,
                })));
                const ws = XLSX.utils.json_to_sheet(mExcel);
        
                // Create a workbook
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Mantto");
        
                // Generate XLSX file and download
                XLSX.writeFile(wb, "mantto.xlsx");
                */
    };
    useEffect(() => {
        setCurrentPageIndex(1);
    }, [checks]);

    const columns = useMemo(() => [
        {
            id: "dateTransaction",
            header: 'ID/Fecha',
            cell: (item: ItemCheck) => <FormField label={
                onSelect ?
                    <Link onClick={() => {
                        onSelect(item)
                    }}>
                        <div>
                            {item.idRequest}</div></Link> : item.idRequest}>
                {item.dateSubmited}

            </FormField>,
            width: 120
        },
        {
            id: "check",
            header: "Chequeo",
            cell: (item: ItemCheck) => (
                <FormField
                    info={
                        <Popover
                            triggerType="custom"
                            content={<StepsCheck check={item} />}
                            dismissButton={false}
                        >
                            <Icon path={mdiTabSearch} size={0.75} />
                        </Popover>
                    }
                    description={item.equipmentCheck == "PLANE" ?
                        "Avión" :
                        item.equipmentCheck === "GLIDER" ?
                            "Planeador" :
                            item.equipmentCheck == "HELI" ? "Helicoptero" : ""}
                    label={item.check}
                />
            )
        },
        showPilot || showInstructor ?
            {
                id: 'departure',
                header: showPilot && showInstructor ? 'Tripulación' : showPilot && !showInstructor ? 'Piloto' : 'Instructor',
                cell: (item: ItemCheck) => (
                    <>
                        {showPilot && showInstructor ? (
                            <FormField label={item.displayName} key={`labelinstructor-${item.idRequest}`}>
                                {item.instructor !== "" ? (
                                    <SpaceBetween direction="horizontal" size="xs" key={`instructor-spacebetween-${item.idRequest}`}>
                                        {/* 🔑 FIX 1: Add keys to the children of SpaceBetween */}
                                        <Icon path={mdiHumanMaleBoard} size={1} key={`icon-${item.idRequest}`} />
                                        <span key={`instructor-name-${item.idRequest}`}>{item.instructor}</span>
                                    </SpaceBetween>
                                ) : null}
                            </FormField>
                        ) : null}

                        {showPilot && !showInstructor ? (
                            <FormField label={item.displayName} key={`labelinstructor-${item.idRequest}`} />
                        ) : null}

                        {!showPilot && showInstructor ? (

                            <SpaceBetween direction="horizontal" size="xs" key={`instructor-spacebetween-${item.idRequest}`}>
                                {/* 🔑 FIX 1: Add keys to the children of SpaceBetween */}
                                <Icon path={mdiHumanMaleBoard} size={1} key={`icon-${item.idRequest}`} />
                                <span key={`instructor-name-${item.idRequest}`}>{item.instructor}</span>
                            </SpaceBetween>
                        ) : null}

                    </>
                ),
            } : null,
        showStatus ?
            {
                id: "data",
                header: "Estado",
                cell: (item: ItemCheck) => (

                    <FormField
                        label={
                            item.statusRequest === -1 ?
                                <><Icon path={mdiCloseOctagon} size={1} color="grey" />Anulado</> :
                                item.statusRequest === 0 ?
                                    <><Icon path={mdiTimerSettings} size={1} color='#f7c500' /> Pendiente</> :
                                    item.statusRequest === 1 ? <><Icon path={mdiClipboardCheck} size={1} color='#006ce0' /> Asignado</> : item.statusRequest === 2 ? <><Icon path={mdiThumbDown} size={1} color="red" />Rechazado</> : item.statusRequest === 3 ? <><Icon path={mdiThumbUp} size={1} color="green" />Aprobado</> : item.statusRequest === -2 ? <><Icon path={mdiClockRemoveOutline} size={1} color="brown" />Expirado</> : <><Icon path={mdiHelpRhombus} size={1} color="lightgrey" />Desconocido</>
                        }
                        description={item.dateResult}
                    />
                )
            } : null,

        showEval ?
            {
                id: "eval",
                header: "Evaluación",
                width: 140,
                cell: (item: ItemCheck) => (

                    <FormField
                        label={
                            item.statusRequest === 1 ? (
                                <>
                                    Evaluar{" "}
                                    {item?.jsonResults?.reduce(
                                        (acc: number, j: any) => acc + (j.resultValue?.trim() !== "" ? 1 : 0),
                                        0
                                    ) ?? 0}/{item?.jsonResults.length}
                                </>
                            ) : null
                        }
                    />
                )
            } : null,
    ].filter(Boolean), [checks, paginated, filtered, currentPageIndex, parameters.pageSize, filterValue]);
    const dataChecks = hidePaging ? filtered : paginated;
    return (
        <>
            <Table
                variant='embedded'
                filter={

                    <SpaceBetween direction='horizontal' size='xs'>
                        {filter ? (

                            <div style={{ width: 300 }}>
                                <TextFilter countText={filterValue === "" ? `${checks.length} registros` : `${paginated.length}/${checks.length}`}
                                    filteringPlaceholder="Filtrar"
                                    filteringText={filterValue}
                                    disabled={checks.length === 0}
                                    onChange={({ detail }) => {
                                        setFilterValue(detail.filteringText);
                                        setCurrentPageIndex(1);
                                    }}
                                />
                            </div>
                        ) : undefined}
                        {excel && (
                            <Button disabled={checks.length === 0} onClick={exportToExcel} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>
                        )}
                    </SpaceBetween>
                }

                pagination={
                    !hidePaging ?
                        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                            {filtered.length > parameters.pageSize && (
                                <Pagination
                                    currentPageIndex={currentPageIndex}
                                    pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                    onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                />
                            )}

                            {checks.length > 0 && (
                                <SelectPaging onSelect={(pageSize) => {
                                    setCurrentPageIndex(1);
                                    setParameters({ ...parameters, pageSize: pageSize });
                                }} />
                            )}
                        </SpaceBetween>
                        : null
                }
                stickyHeader
                columnDefinitions={columns}
                trackBy="idRequest"
                items={paginated ?? []}

                empty={
                    <Box
                        margin={{ vertical: "xs" }}
                        textAlign="center"
                        color="inherit"
                    >
                        <SpaceBetween size="m">
                            <b>Sin chequeos asociados</b>
                        </SpaceBetween>
                    </Box>
                }
            />

        </>
    );
};

export default TableChecks;